module.exports = __webpack_public_path__ + "img/timer-play-outline.513aa247.svg";